import axios from "axios";
import { BASE_URL, USER_URL } from "../constant/api";

export const AddProductsApi = async (formData) => {
  try {
    console.log("form data", formData);
    
    const response = await USER_URL.post("/products/seller/", formData
    //   , {
    //   headers: { "Content-Type": "multipart/form-data" },
    // }
  );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in add product", error);
    throw error;
  }
};

export const AdminAddProductsApi = async (formData) => {
  try {
    console.log("form data", formData);
    const response = await USER_URL.post("/products/admin/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in add product", error);
    throw error;
  }
};

export const FetchAllSellers = async () => {
  try {
    const response = await USER_URL.get("/accounts/admin/companies/");
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("error in fetch sellers", error);
    throw error;
  }
}

export const FetchProductsApi = async () => {
  try {
    const response = await USER_URL.get("/products/seller/");
    // console.log("seller Products", response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch products", error);
    throw error;
  }
};

//delete product

export const DeleteProductsApi = async (id) => {
  try {
    const response = await USER_URL.delete(`/products/seller/${id}/`);
    // console.log(response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch products", error);
    throw error;
  }
};

// update product details

export const EditProductApi = async (productId, formData) => {
  console.log("edit api ", productId);

  try {
    const response = await USER_URL.patch(
      `/products/seller/${productId}/`,
      formData,
      // {
      //   headers: { "Content-Type": "multipart/form-data" },
      // },
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in add product", error);
    throw error;
  }
};
//fetch product by id
export const FetchProductByIdApi = async ({ id }) => {
  console.log(id);

  try {
    const response = await USER_URL.get(`/products/seller/${id}/`);
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("error in fetch product", error);
    throw error;
  }
};

// add  products images

export const AddProductImagesApi = async (formData) => {
  try {
    const response = await USER_URL.patch("accounts/product/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("Error in add product", error);
    throw error;
  }
};

// fetch category
export const FetchCategoryApi = async ({ categoryId }) => {
  try {
    // console.log('category id',categoryId);

    const response = await axios.get(`${BASE_URL}/categories/${categoryId}/`);
    // console.log('category',response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch category", error);
    throw error;
  }
};
//fetch all categories
export const FetchAllCategoryApi = async () => {
  try {
    // console.log('category id',categoryId);

    const response = await axios.get(`${BASE_URL}/categories/`);
    // console.log('category',response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch category", error);
    throw error;
  }
};
// fetch subcategory

export const FetchSubcategoriesApi = async (categoryId) => {
  try {
    console.log('category id 1',categoryId);

    const response = await axios.get(
      `${BASE_URL}/categories/${categoryId}/subcategory/`,
    );
    console.log("sub category", response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch subcategory", error);
    throw error;
  }
};

//fetch seller products

export const FetchSellerProductsApi = async ({ sellerId }) => {
  try {
    // console.log('category id',categoryId);

    const response = await axios.get(
      `${BASE_URL}/products/all-sellers${sellerId}/`,
    );
    // console.log("sller products", response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch category", error);
    throw error;
  }
};

/////////////////////////////////////////////////////
// sponser products

export const FetchSponsor = async () => {
  try {
    // console.log('category id',categoryId);

    const response = await USER_URL.get(`/products/seller/sponsored/`);
    // console.log("sllersponsor  ", response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch sponsor ", error);
    throw error;
  }
};

export const FetchSponsorProducts = async (sponsorId) => {
  try {
    // console.log("category id", sponsorId);

    const response = await USER_URL.get(
      `/products/seller/sponsored/${sponsorId}/`,
    );
    // console.log("sllersponser  products", response.data);

    return response.data.Data;
  } catch (error) {
    console.log("error in fetch sponser view", error);
    throw error;
  }
};

export const UpdateSponsorProducts = async (sponsorId, formData) => {
  try {
    console.log("create data", formData);
    const response = await USER_URL.put(
      `/products/seller/sponsored/${sponsorId}/`,
       formData ,
    );
    console.log("sllersponsor  update products", response.data);

    return response.data.Data;
  } catch (error) {
    console.log("error in sponsor update", error);
    throw error;
  }
};

export const CreateSponsor = async (formData) => {
  try {
    

    const response = await USER_URL.post(
      `/products/seller/sponsored/`,
      formData,
    );
    // console.log("sllersponsor create", response.data);

    return response.data.Data;
  } catch (error) {
    console.log("error in sponsor create", error);
    throw error;
  }
};

export const DeleteSponsorApi = async (sponsorId) => {
  try {
    const response = await USER_URL.delete(
      `/products/seller/sponsored/${sponsorId}/`,
    );
    // console.log("sllersponser delete", response.data);

    return response.data;
  } catch (error) {
    console.log("error in sponsor delete", error);
    throw error;
  }
};

export const fetchAdminSponsor = async (filter)=>{
  console.log("filter", filter);
  
  try {
    const url = filter 
      ? `/products/admin/sponsored/?status=${filter}` 
      : `/products/admin/sponsored/`;

    const response = await USER_URL.get(url); 
    console.log(response.data);

    return response.data;
  } catch (error) {
    console.log("error in fetch sponsor ", error);
    throw error;
  }
}

export const FetchAdminSponsorProducts = async (sponsorId) => {
  try {
    // console.log("category id", sponsorId);

    const response = await USER_URL.get(
      `/products/admin/sponsored/${sponsorId}/`,
    );
    // console.log("sllersponser  products", response.data);

    return response.data.Data;
  } catch (error) {
    console.log("error in fetch sponser view", error);
    throw error;
  }
};

export const DeleteProductImageApi = async (productId,imageId) => {
  try {
    const response = await USER_URL.delete(
      `/products/seller/${productId}/image/${imageId}/`,
    );
    console.log("sllers image  delete", response.data);

    return response.data;
  } catch (error) {
    console.log("error in image delete", error);
    throw error;
  }
}